import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSession } from '../session';
import { ApiError } from '../api';
import { AuthShell } from '../Brand';

export function SignIn() {
  const { signIn } = useSession();
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      await signIn(login.trim(), password);
    } catch (err) {
      const e2 = err as ApiError;
      // An account with no password yet gets this same answer, by design: on
      // the day Learnica replaces TalentLMS that is everybody, and the link
      // underneath is how they set one.
      setError(e2.body?.reason === 'locked'
        ? 'Too many failed attempts. Try again in a few minutes.'
        : e2.body?.reason === 'inactive'
        ? 'This account is no longer active. Contact Qatar Care training.'
        : 'That username or password is not right. New here, or forgotten it? Use the link below to set one.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell>
      <form className="gate__card" onSubmit={submit}>
        <h1 className="gate__title">Sign in</h1>

        <label htmlFor="login">Username or email</label>
        <input id="login" value={login} onChange={(e) => setLogin(e.target.value)} autoComplete="username" autoFocus required />

        <label htmlFor="password">Password</label>
        <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />

        {error && <p className="auth__error" role="alert">{error}</p>}

        <button className="btn btn--primary btn--block" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>

        <Link className="gate__link" to="/forgot-password">I have forgotten my password</Link>
        {/* On the day Learnica replaces TalentLMS nobody has a password here
            yet, because TalentLMS never exported them. This is the line every
            one of them needs, so it is on the page rather than in an error. */}
        <p className="gate__first">
          First time on Learnica? <Link to="/forgot-password">Set your password</Link> with the email
          address Qatar Care has for you.
        </p>
      </form>
    </AuthShell>
  );
}
